import PropTypes from 'prop-types';
import React from 'react';

import { StaticTitle } from '$partials/layout/side-titles.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const TextLarge = ({
    sideTitle = null,
    text      = null
}) => {
    // render
    return (
        <section className='module-text-large'>
            <div className='pr-gutter mxn-gutter'> {/* outer grid gutter */}
                <div className='flex flex-wrap'>
                    {/* side title */}
                    <div className='absolute top-0 md-relative md-col-2'>
                        {sideTitle && (
                            <div className='px-gutter'>
                                <p className='type-style-5 side-title'>
                                    <StaticTitle title={sideTitle} />
                                </p>
                            </div>
                        )}
                    </div>

                    {/* content */}
                    <div className='col-11 sm-col-8 md-col-7'>
                        <div className='ml9 sm-ml9 md-ml0'>
                            {text && (
                                <div className='px-gutter'>
                                    <div
                                        className='rich-text type-style-1'
                                        dangerouslySetInnerHTML={{ __html: text }}/>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    sideTitle: PropTypes.string,
    text     : PropTypes.string.isRequired,
};

TextLarge.propTypes = propTypes;

export { TextLarge };

export default TextLarge;
